import React, { memo } from 'react';
import PropTypes from 'prop-types';

const TopBarCard = ({
  children,
  elevated = false,
  transparent = false,
  className = '',
  ...props
}) => {
  const cardClasses = [
    'card',
    elevated ? 'elevated' : '',
    transparent ? 'transparent' : '',
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={cardClasses} {...props}>
      {children}
    </div>
  );
};

const arePropsEqual = (prevProps, nextProps) => {
  return (
    prevProps.elevated === nextProps.elevated &&
    prevProps.transparent === nextProps.transparent &&
    prevProps.className === nextProps.className &&
    prevProps.children === nextProps.children
  );
};

TopBarCard.propTypes = {
  children: PropTypes.node,
  elevated: PropTypes.bool,
  transparent: PropTypes.bool,
  className: PropTypes.string
};

TopBarCard.defaultProps = {
  elevated: false,
  transparent: false,
  className: ''
};

TopBarCard.displayName = 'TopBarCard';

export default memo(TopBarCard, arePropsEqual);